import { Component, OnInit, Input } from '@angular/core';
import { RegisterService } from 'src/app/services/register/register.service';
import { AlertListService } from '@xref/ngx';

@Component({
    selector: 'xlog-pending-verification',
    templateUrl: './pending-verification.component.pug',
    styleUrls: ['./pending-verification.component.scss'],
    standalone: false
})
export class PendingVerificationComponent {
    @Input() email: string;

    constructor(
        private reg: RegisterService,
        private alertList: AlertListService
    ) {}

    resendLinkSuccess = (data) => {
        this.alertList.append([{active: true, type: 'success', messageKey: 'pendingVerification.resendLinkSuccess', messageParameters: {email: this.email}}]);
    };

    resendLinkError = (err) => {
        this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    resendLink() {
        this.reg.resendLinkByEmail(this.email).subscribe(
            this.resendLinkSuccess,
            this.resendLinkError
        );
    }
}
